import React from "react";
import { LayoutProps } from "@refinedev/core";
import { Box, Container } from "@mantine/core";

import { Sider as DefaultSider } from "../sider";
import { Header as DefaultHeader } from "../header";

export const Layout: React.FC<LayoutProps> = ({
  Sider,
  Header,
  Footer,
  OffLayoutArea,
  children,
}) => {
  const SiderToRender = Sider ?? DefaultSider;
  const HeaderToRender = Header ?? DefaultHeader;

  return (
    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      <SiderToRender />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          minWidth: 0,
        }}
      >
        <HeaderToRender />
        <Box
          component="main"
          sx={(theme) => ({
            padding: `${theme.spacing.md}px ${theme.spacing.md}px ${theme.spacing.xl}px`,
            minHeight: "calc(100vh - 72px)",
          })}
        >
          <Container size="xl" px={0} sx={{ minWidth: 0 }}>
            {children}
          </Container>
        </Box>
        {Footer && <Footer />}
      </Box>
      {OffLayoutArea && <OffLayoutArea />}
    </Box>
  );
};
